<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="container my-5 d-body">
  <div>
    <div class="my-3 d-flex justify-content-between">
      <div class="font20">System Privileges</div>
      <div>
          <button class="btn btn-outline-secondary btn-sm mr-3"  data-toggle="modal" data-target="#addModal">Add Role</button>
          <button class="btn btn-secondary btn-sm">Save</button>
      </div>
    </div>

    <div>
      <div class="row">
        <div class="col-lg-3 col-sm-12  vertical-nav my-3">
          <div class="bg-white border-radius py-4">
            <div class="px-3 font18">Roles</div>
            <hr />
            <div
              class="nav flex-column nav-pills px-2"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <a
                class="nav-link active"
                id="v-pills-home-tab"
                data-toggle="pill"
                href="#v-pills-home"
                role="tab"
                aria-controls="v-pills-home"
                aria-selected="true"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    Home
                  </div>
                  <div>
                    <img src="assets/images/close.png" alt="" />
                  </div>
                </div>
              </a>
              <a
                class="nav-link"
                id="v-pills-profile-tab"
                data-toggle="pill"
                href="#v-pills-profile"
                role="tab"
                aria-controls="v-pills-profile"
                aria-selected="false"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    Profile
                  </div>
                  <div>
                    <img src="assets/images/close.png" alt="" />
                  </div>
                </div>
              </a>
              <a
                class="nav-link"
                id="v-pills-messages-tab"
                data-toggle="pill"
                href="#v-pills-messages"
                role="tab"
                aria-controls="v-pills-messages"
                aria-selected="false"
                ><div class="d-flex align-items-center justify-content-between">
                  <div>
                    messages
                  </div>
                  <div>
                    <img src="assets/images/close.png" alt="" />
                  </div></div
              ></a>
              <a
                class="nav-link"
                id="v-pills-settings-tab"
                data-toggle="pill"
                href="#v-pills-settings"
                role="tab"
                aria-controls="v-pills-settings"
                aria-selected="false"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    settings
                  </div>
                  <div>
                    <img src="assets/images/close.png" alt="" />
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>

        <div class="col-lg-9 col-sm-12 my-3">
          <div class="bg-white border-radius py-4">
            <div class="px-3 ">
              <h5 class="font18">Privileges</h5>
            </div>
            <hr />
            <div class="tab-content" id="v-pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="v-pills-home"
                role="tabpanel"
                aria-labelledby="v-pills-home-tab"
              >
                <div class="p-3">
                  <div>
                    <div>
                      <p class="font-bold mb-0">User Management</p>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Add/Remove Staff</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Approve Registration</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Assign Roles</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Setup Company Structure</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Update Staff Profile</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Modify Company Profile</span>
                      </div>
                    </div>
                    <div class="">
                      <p class="font-bold mt-4">Content Management</p>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >Add/Remove Course Content & Assessment</span
                        >
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Manage Course Category</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >Make a Comment on/Rate a Course</span
                        >
                      </div>
                    </div>
                    <div class="">
                      <p class="font-bold mt-4">Learning Administration</p>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >Add/Remove Course Content & Assessment</span
                        >
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Manage Course Category</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >Make a Comment on/Rate a Course</span
                        >
                      </div>
                    </div>
                    <div class="">
                      <p class="font-bold mt-4">Learning Management</p>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">View Assessment & Results</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Take a Course & Assessment</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >View Assessment of Other Staff (General)</span
                        >
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >View Assessment of Other Staff (Specific)</span
                        >
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Recomment & Share Courses </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="v-pills-profile"
                role="tabpanel"
                aria-labelledby="v-pills-profile-tab"
              >
                <div class="p-3">
                  <div>
                    <div>
                      <p class="font-bold mb-0">User Management</p>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Add/Remove Staff</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Approve Registration</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Assign Roles</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Setup Company Structure</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Update Staff Profile</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Modify Company Profile</span>
                      </div>
                    </div>
                    <div class="">
                      <p class="font-bold mt-4">Content Management</p>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >Add/Remove Course Content & Assessment</span
                        >
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Manage Course Category</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >Make a Comment on/Rate a Course</span
                        >
                      </div>
                    </div>
                    <div class="">
                      <p class="font-bold mt-4">Learning Administration</p>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >Add/Remove Course Content & Assessment</span
                        >
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Manage Course Category</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >Make a Comment on/Rate a Course</span
                        >
                      </div>
                    </div>
                    <div class="">
                      <p class="font-bold mt-4">Learning Management</p>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">View Assessment & Results</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Take a Course & Assessment</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >View Assessment of Other Staff (General)</span
                        >
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >View Assessment of Other Staff (Specific)</span
                        >
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Recomment & Share Courses </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="v-pills-messages"
                role="tabpanel"
                aria-labelledby="v-pills-messages-tab"
              >
                <div class="p-3">
                  <div>
                    <div>
                      <p class="font-bold mb-0">User Management</p>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Add/Remove Staff</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Approve Registration</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Assign Roles</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Setup Company Structure</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Update Staff Profile</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Modify Company Profile</span>
                      </div>
                    </div>
                    <div class="">
                      <p class="font-bold mt-4">Content Management</p>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >Add/Remove Course Content & Assessment</span
                        >
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Manage Course Category</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >Make a Comment on/Rate a Course</span
                        >
                      </div>
                    </div>
                    <div class="">
                      <p class="font-bold mt-4">Learning Administration</p>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >Add/Remove Course Content & Assessment</span
                        >
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Manage Course Category</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >Make a Comment on/Rate a Course</span
                        >
                      </div>
                    </div>
                    <div class="">
                      <p class="font-bold mt-4">Learning Management</p>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">View Assessment & Results</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Take a Course & Assessment</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >View Assessment of Other Staff (General)</span
                        >
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >View Assessment of Other Staff (Specific)</span
                        >
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Recomment & Share Courses </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="v-pills-settings"
                role="tabpanel"
                aria-labelledby="v-pills-settings-tab"
              >
                <div class="p-3">
                  <div>
                    <div>
                      <p class="font-bold mb-0">User Management</p>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Add/Remove Staff</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Approve Registration</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Assign Roles</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Setup Company Structure</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Update Staff Profile</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Modify Company Profile</span>
                      </div>
                    </div>
                    <div class="">
                      <p class="font-bold mt-4">Content Management</p>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >Add/Remove Course Content & Assessment</span
                        >
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Manage Course Category</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >Make a Comment on/Rate a Course</span
                        >
                      </div>
                    </div>
                    <div class="">
                      <p class="font-bold mt-4">Learning Administration</p>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >Add/Remove Course Content & Assessment</span
                        >
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Manage Course Category</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >Make a Comment on/Rate a Course</span
                        >
                      </div>
                    </div>
                    <div class="">
                      <p class="font-bold mt-4">Learning Management</p>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">View Assessment & Results</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Take a Course & Assessment</span>
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >View Assessment of Other Staff (General)</span
                        >
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14"
                          >View Assessment of Other Staff (Specific)</span
                        >
                      </div>
                      <div class="my-3 d-flex">
                        <label class="check-container">
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <span class="font14">Recomment & Share Courses </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-auto">
    <hr />
    <iq-central-front-end-footer></iq-central-front-end-footer>
  </div>
</section>

<!-- Modal -->
<div class="modal fade" id="addModal" tabindex="-1" role="dialog" aria-labelledby="addModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font18" id="addModalLabel">Add Role</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body pt-5">
          <form class="d-flex">
              <input type="text" placeholder="Enter Division Name" class="common-input"/> <span class="text-red">*</span>
          </form>
        <div class="my-5 text-center">
          <button type="button" class="btn btn-secondary">Add</button>
        </div>
        </div>
      </div>
    </div>
  </div>